import { FieldsType } from '../../Types'
import { FieldGroup, LayoutProps } from '../Type'

export const makeGroup = (
  fields: FieldsType[],
  layout: LayoutProps[] | undefined
): FieldGroup[] => {
  const fieldsGroups: FieldGroup[] = [
    {
      group: 'default',
      className: 'default',
      fields: [],
      order: 99,
    },
  ]

  fields.forEach((field) => {
    const groupId = field.group ? field.group : 'default'
    const haveGroup = fieldsGroups.find((el) => el.group === groupId)
    const haveLayout = layout ? layout.find((el) => el.group === groupId) : null
    if (haveGroup) {
      haveGroup.fields.push(field)
    } else if (haveLayout) {
      fieldsGroups.push({
        group: haveLayout.group,
        className: haveLayout.className,
        fields: [field],
        order: haveLayout.order,
      })
    }
  })
  return fieldsGroups.sort((a, b) => a.order - b.order)
}
